import React from 'react';
import styles from './LoadingDetailsPage.module.css';
import { Card } from '../../../../components/Card';
import { VBox } from '../../../../components/Box';
import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    justify-content: center;
    max-width: 100%;
  }
  .info-card {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    height: 500px;
  }

  .info-card-1 {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    height: 250px;
    padding: 22px;
  }
  .info-card-2 {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    height: 550px;
    padding: 22px 22px 22px 22px;
  }
  .info-card-3 {
    min-width: 260px;
    width: 100%;
    margin: 10px 0;
    height: auto;
    padding: 22px;
    border: none;
    box-shadow: none;
  }

  .vbox.col {
    width: 100%;

    @media (max-width: 768px) {
      max-width: 100%;
    }
  }
`;
const CardPlaceholder = () => <div className={styles.cardPlaceholder} />;

const LoadingDetailsPage = ({ version }) => {
  const createPlaceholders = count => Array.from({ length: count }, (_, index) => <CardPlaceholder key={index} />);

  const createCard = (cardClass, placeholderCount, image = false) => (
    <Card className={`vehicle-info-card ${cardClass}`}>
      {image && (
        <div className={styles.img}></div>
      )}
      {createPlaceholders(placeholderCount)}
    </Card>
  );

  const renderVersionVehicle = () => (
    <Container className={styles.containerPage}>
      <VBox left className="col" top>
        {createCard('info-card misc', 4, true)}
        {createCard('info-card misc', 4)}
      </VBox>
      <VBox left className="col" top>
        {createCard('info-card-1 misc', 4)}
      </VBox>
      <VBox left className="col" top>
        {createCard('info-card-2 misc', 4, true)}
      </VBox>
      <VBox left className="col align-items-end" top>
        {createCard('info-card misc', 6)}
        {createCard('info-card misc', 6)}
      </VBox>
    </Container>
  );

  const renderVersionInvoice = () => (
    <Container className={styles.containerInvoice}>
      <VBox left className="col" top>
        {createCard('info-card-3 misc', 4)}
        {createCard('info-card-3 misc', 4)}
        {createCard('info-card-3 misc', 4)}
      </VBox>
      <VBox left className="col" top>
        {createCard('info-card-3 misc', 4)}
        {createCard('info-card-3 misc', 4)}
        {createCard('info-card-3 misc', 4)}
      </VBox>
      <VBox left className="col" top>
        {createCard('info-card-3 misc', 4)}
        {createCard('info-card-3 misc', 4)}
        {createCard('info-card-3 misc', 4)}
      </VBox>
    </Container>
  );

  const renderVersionCompanies = () => (
    <Container className={styles.containerPage}>
      <VBox left className="col" top>
        {createCard('info-card misc', 4)}
        {createCard('info-card misc', 4)}
      </VBox>
      <VBox left className="col" top>
        {createCard('info-card-1 misc', 4)}
      </VBox>
      <VBox left className="col" top>
        {createCard('info-card-1 misc', 4)}
      </VBox>
      <VBox left className="col align-items-end" top>
        {createCard('info-card misc', 6)}
        {createCard('info-card misc', 6)}
      </VBox>
    </Container>
  );

  const renderContent = () => {
    if (window.innerWidth <= 768) {
      return version === 'versionVehicle' ? createCard('info-card misc', 4, true) : renderVersionInvoice();
    }

    switch (version) {
      case 'versionVehicle':
        return renderVersionVehicle();
      case 'versionInvoice':
        return renderVersionInvoice();
      case 'versionCompanies':
        return renderVersionCompanies();
      default:
        return renderVersionInvoice();
    }
  };

  return <>{renderContent()}</>;
};

export default LoadingDetailsPage;
